import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import * as React from "react";

interface Props {
  value: string;
  style?: React.CSSProperties;
  className?: string;
}

export const CopyButtonWithApproval: React.FC<Props> = ({ value, className = "", style = {} }) => {
  const [isCopied, setIsCopied] = React.useState(false);

  React.useEffect(() => {
    let intervalId: any;
    if (isCopied) {
      intervalId = setInterval(() => {
        setIsCopied(false);
      }, 1500);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isCopied]);

  function handleCopyToClipboard() {
    setIsCopied(true);
    navigator.clipboard.writeText(value);
  }

  return (
    <button
      type={`button`}
      onClick={handleCopyToClipboard}
      style={{ ...style, outline: 0 }}
      className={`inline ${className}`}
    >
      {!isCopied ? <CopyOutlined className="color-link-hover" /> : <CheckOutlined className="color-link" />}
    </button>
  );
};
